import { ITranslate } from "@/interfaces/ITranslate";

export const worksheetHasUsersTranslate: ITranslate = {
  isTeamLeader: "es jefe",
  projectHasDietTypeId: "el tipo de dieta del proyecto",
  // @Deprecated
  dietCost: "el coste de la dieta",
  dietTypeId: "el tipo de dieta",
};
